import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../utils/customBaseQuery";

export const SearchAPI = createApi({
  reducerPath: "searchAPI",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getSearchResult: builder.query({
      query: ({ searchQuery, pageNumber }) => ({
        url: `/escore/search?pageNumber=${pageNumber}&pageSize=10&sortKey=_score&sortOrder=DESC&relevance=true&indexName=tms&indexName=content`,
        method: "POST",
        body: {
          title: searchQuery ?? undefined,
          shortdescription: searchQuery ?? undefined,
          expectedoutcome: searchQuery ?? undefined,
          longdescription: searchQuery ?? undefined,
          "searchtags.defaultTag": searchQuery ?? undefined,
          "session.title": searchQuery ?? undefined,
          "session.shortdescription": searchQuery ?? undefined,
          "session.longdescription": searchQuery ?? undefined,
          "session.searchtags.defaultTag": searchQuery ?? undefined,
          "session.agenda.title": searchQuery ?? undefined,
          "session.agenda.shortdescription": searchQuery ?? undefined,
          "session.agenda.longdesription": searchQuery ?? undefined,
          "session.agenda.searchtags.defaultTag": searchQuery ?? undefined,
          short_description: searchQuery ?? undefined,
          learningObjectives: searchQuery ?? undefined,
          searchTags: searchQuery ?? undefined,
          "skills.skillname": searchQuery ?? undefined,
          long_description: searchQuery ?? undefined,
          demonstrableOutcome: searchQuery ?? undefined
        }
      }),
      extraOptions: { service: "Elastic_Core" }
    })
  })
});

export const { useLazyGetSearchResultQuery, useGetSearchResultQuery } =
  SearchAPI;
